<template>
  <div class="layout__menu" v-responsive.lg.xl>
    <div class="layout__menu__logo">
      <a :href="logoLink" target="_blank">
        <img :src="logoImgUrl" style="height: 41px; width: auto;" :alt="logoImgAlt" />
      </a>
    </div>
    <div class="layout__menu__nav">
      <router-link
        :to="newRouteLink"
        class="layout__menu__nav__item test-button-dashboard"
        v-bind:class="{'layout__menu__nav__item--active': $route.name === 'dashboard'}"
        exact
      >
        <div class="layout__menu__nav__item__wrapper">
          <BaseIcon icon="dashboard"></BaseIcon>
          <div class="layout__menu__nav__item__name">{{ $t('dashboard.title') }}</div>
        </div>
      </router-link>
      <a v-if="user.is_dealer" :href="adminUrl" target="_blank" class="layout__menu__nav__item test-button-server-status">
        <div class="layout__menu__nav__item__wrapper">
          <BaseIcon icon="settings"></BaseIcon>
          <div class="layout__menu__nav__item__name">
            {{adminTextLink}}
          </div>
        </div>
      </a>
      <router-link :to="{ name: 'sigfox-coverage' }" class="layout__menu__nav__item test-button-sigfox-coverage" v-if="showInEnv([env_tentacles, env_flower])">
        <div class="layout__menu__nav__item__wrapper">
          <BaseIcon icon="server"></BaseIcon>
          <div class="layout__menu__nav__item__name">
            {{ $t('sigfox_coverage.title') }}
          </div>
        </div>
      </router-link>
    </div>
    <div class="layout__menu__contact">
<!--    <button @click="showContactModal()" class="layout__menu__contact__btn">  -->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import LayoutContactModal from '@/layout/contact/LayoutContactModal.vue';

export default {
  name: 'LayoutMenu',
  data() {
    return {
      env_emeta: process.env.VUE_APP_ENV_EMETA,
      env_tentacles: process.env.VUE_APP_ENV_TENTACLES,
      env_etentacles: process.env.VUE_APP_ENV_ETENTACLES,
      env_flower: process.env.VUE_APP_ENV_FLOWER,
      logoImgUrl: process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER ? '/flower_logo.png' : '/Tentacles_IoT_logo.png',
      logoImgAlt: process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER ? 'Floweryourplace' : 'TentaclesIoT',
      logoLink: process.env.VUE_APP_ENV_LOGO_LINK,
      adminUrl: process.env.VUE_APP_API_URL,
    };
  },
  computed: {
    ...mapGetters('tentacle', ['user', 'type', 'is_dealer']),
    newRouteLink() {
      return {
        name: 'dashboard',
        params: {
          type: (this.type && this.type.urlSlug) ? this.type.urlSlug : null,
        },
      };
    },
    adminTextLink() {
      if (process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_ETENTACLES) {
        return 'Admin YourTentacles';
      }
      if (process.env.VUE_APP_ENVIRONMENT === process.env.VUE_APP_ENV_FLOWER) {
        return 'Admin Flower your place';
      }
      return 'Admin MyTentacles';
    },
  },
  methods: {
    showInEnv(type) {
      if (Array.isArray(type)) {
        return type.includes(process.env.VUE_APP_ENVIRONMENT);
      }
      return process.env.VUE_APP_ENVIRONMENT === type;
    },
    showContactModal() {
      this.$modal.show(LayoutContactModal, {}, { width: 400, height: 415, transition: 'fade' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import 'layout-menu';
</style>
